const teamCardTogglers = document.querySelectorAll(".card--team .card-link");
teamCardTogglers.forEach((toggler) => {
    toggler.addEventListener("click", () => {
        const card = toggler.closest(".nu-card");
        card.classList.toggle("open");
    });
});
